import { Route } from 'react-router-dom'
import { AlbumDesignRoot } from './layouts/AlbumDesignRoot'
import { AlbumShellLayout } from './layouts/AlbumShellLayout'
import { AlbumImmersiveLayout } from './layouts/AlbumImmersiveLayout'
import { CreateAlbumLayout } from './layouts/CreateAlbumLayout'
import { GuestAlbumLayout } from './layouts/GuestAlbumLayout'
import { AlbumLibraryScreen } from './screens/AlbumLibrary'
import { CreateAlbumScreen } from './screens/CreateAlbum'
import { AlbumViewScreen } from './screens/AlbumView'
import { GuestAlbumScreen } from './screens/GuestAlbum'
import { GalleryLibraryScreen } from './screens/GalleryLibrary'
import { Try3DScreen } from './screens/Try3D'
import { GalleryWizardScreen } from '@/features/gallery-wizard'
// Legacy 2D pattern-editor shell — used to own `/galleries/:galleryId/studio`
// before that path was handed to the Babylon `gallery-studio-3d` editor
// (promoted from `studio-next`). Re-mounted here at `-classic` instead, for
// side-by-side comparison against the new editor on the same gallery.
import { galleryStudioRouteElements } from '@/features/gallery-studio/routes'
import { galleryStudio3DRouteElements, galleryGuestRouteElements } from '@/features/gallery-studio-3d/routes'
import { settingsRouteElements } from '@/features/settings/routes'
import { notificationsRouteElements } from '@/features/notifications/routes'
import { connectionsRouteElements } from '@/features/connections/routes'
import { profileRouteElements } from '@/features/profile/routes'
import { searchRouteElements } from '@/features/search/routes'
import { discoverRouteElements } from '@/features/discover/routes'
import { spacesRouteElements } from '@/features/spaces'

/**
 * Album product routes — mount inside RootRouter.
 *
 * /albums                  library (minimal shell)
 * /albums/new              create (focused stage, no sidebar)
 * /albums/:albumId         immersive view
 * /albums/:albumId/to-3d   3D gallery wizard
 * /galleries               user's 3D galleries
 * /galleries/try-3d        live 3D walkthrough demo (marketing preview)
 * /galleries/:galleryId/studio        gallery studio — Babylon 3D editor (formerly `studio-next`)
 * /galleries/:galleryId/studio-classic  legacy 2D pattern-editor shell — this used to be at `/studio`
 *                                       before the above took that path; kept for side-by-side comparison
 * /spaces                  catalog of real Space prototypes (Hall, Mountain Lot, …)
 * /a/:shareId              guest public (no auth)
 * /g/:shareId              3D gallery guest public render (no auth)
 * /settings                account settings (replaces /profile/me, /profile/v2)
 * /notification            notifications (replaces the bell dropdown + legacy flat list)
 * /connections             connection graph (replaces the legacy /connections page)
 * /search                  global search results (replaces the legacy /search page)
 * /discover                public feed of other members' opt-in albums & galleries
 */
export const albumRouteElements = (
  <>
    <Route element={<AlbumDesignRoot />}>
      <Route path='albums' element={<AlbumShellLayout />}>
        <Route index element={<AlbumLibraryScreen />} />
      </Route>
      <Route path='albums/new' element={<CreateAlbumLayout />}>
        <Route index element={<CreateAlbumScreen />} />
      </Route>
      <Route path='galleries' element={<AlbumShellLayout />}>
        <Route index element={<GalleryLibraryScreen />} />
      </Route>
      <Route path='galleries/try-3d' element={<Try3DScreen />} />
      <Route path='albums/:albumId' element={<AlbumImmersiveLayout />}>
        <Route index element={<AlbumViewScreen />} />
        <Route path='to-3d' element={<GalleryWizardScreen />} />
      </Route>
      {galleryStudio3DRouteElements}
      {galleryStudioRouteElements}
      {settingsRouteElements}
      {notificationsRouteElements}
      {connectionsRouteElements}
      {profileRouteElements}
      {searchRouteElements}
      {discoverRouteElements}
      {spacesRouteElements}
    </Route>

    <Route path='a/:shareId' element={<GuestAlbumLayout />}>
      <Route index element={<GuestAlbumScreen />} />
    </Route>

    {galleryGuestRouteElements}
  </>
)
